module.exports = "<div class=\"d-flex justify-content-center align-items-center h-100\">\n  <p>Redirection vers Intercom en cours...</p>\n</div>\n"